<template>
  <div class="header">
    <div v-if="showSteps" class="steps">
      <button :style="{ visibility: (assessment.step.index > 0) ? 'initial' : 'hidden' }" @click="assessment.previousStep()" title="Previous step" class="btn btn-arrow left">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847">
          <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
            c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
            c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"/>
        </svg>
      </button>
      <template v-for="step in steps" :key="step.index">
        <div v-if="assessment.step.index == step.index" class="active">
          <span class="title">{{step.title}}</span>
          <span class="short-title">{{step.shortTitle}}</span>
        </div>
        <div v-else-if="!assessment.isActive()">
          <span class="title">{{step.title}}</span>
          <span class="short-title">{{step.shortTitle}}</span>
        </div>
        <button v-else @click="assessment.setStep(step, true)" class="btn">
          <span class="title">{{step.title}}</span>
          <span class="short-title">{{step.shortTitle}}</span>
        </button>
        <div v-if="step.index < 3" class="separator">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="451.846px" height="451.847px" viewBox="0 0 451.846 451.847">
            <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
              L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
              c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
          </svg>
        </div>
      </template>
      <button :style="{ visibility: ((assessment.step.index < 3) && assessment.isActive()) ? 'initial' : 'hidden' }" @click="assessment.nextStep()" title="Next step" class="btn btn-arrow right">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="451.846px" height="451.847px" viewBox="0 0 451.846 451.847">
          <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
            L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
            c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
        </svg>
      </button>
    </div>
    <div v-if="countries.length && basins.length && crops.length && (assessment.branding != 'sbtn')" class="user">
      <template v-if="!userModel.user">
        <span><i class="fa-solid fa-user me-2"></i>anonymous</span>
        <button @click="userModel.login()" title="Log in" class="btn right"><i class="fa-solid fa-right-to-bracket"></i></button>
      </template>
      <template v-else>
        <button @click="userModel.loadUsers()" title="Show user info" class="btn active"><i class="fa-solid fa-user me-2"></i>{{ userModel.user.username }}</button>
        <button @click="userModel.logout()" title="Log out" class="btn right"><i class="fa-solid fa-right-from-bracket"></i></button>
      </template>
    </div>
  </div>
</template>

<script>
import { assessment, steps } from "@/services/assessment-model.js";
import { countries, basins, crops } from "@/services/entity-model.js";
import { userModel } from "@/services/user-model.js";

export default {
  name: "Header",
  props: {
    showSteps: { type: Boolean, default: true }
  },
  data() {
    return {
      countries,
      basins,
      crops,
      userModel,
      assessment,
      steps
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  height: 60px;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.5);
  background-color: var(--bs-primary);
}
.btn {
  border: none;
  padding: 0;
  font-size: 22px;
  color: inherit;
  transition: all 0.3s;
  &:hover {
    color: #fff;
    text-decoration: underline;
    &.left {
      transform: translateX(-5px);
    }
    &.right {
      transform: translateX(5px);
    }
  }
}
.active {
  color: #fff;
  &.btn {
    font-size: 16px;
    font-weight: 600;
    text-decoration-thickness: 2px;
  }
}
.steps {
  display: flex;
  height: 100%;
  font-family: "rubrikregular";
  font-size: 22px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  .btn-arrow {
    border-radius: 50%;
    padding: 2px;
    background-color: rgba(255, 255, 255, 0.5);
    transition: all 0.3s, visibility 0s;
    &:hover {
      background-color: #fff;
    }
    svg {
      display: block;
      width: 25px;
      height: 25px;
      border: 2px solid var(--bs-primary);
      border-radius: 50%;
      padding: 5px;
      fill: var(--bs-primary);
    }
  }
  .title {
    display: inline;
    @media (max-width: 1200px) {
      display: none;
    }
  }
  .short-title {
    display: none;
    @media (max-width: 1200px) {
      display: inline;
    }
  }
  .separator {
    svg {
      width: 16px;
      height: 16px;
      fill: rgba(255, 255, 255, 0.5);
    }
  }
}
.user {
  display: flex;
  position: absolute;
  left: 12px;
  top: 0;
  height: 100%;
  align-items: center;
  gap: 12px;
}
</style>
